<script setup lang="ts">
import type { IFormSentProps } from '@/cms-ui/components/LeadForm/ts/types'

defineProps<IFormSentProps>()

const emit = defineEmits<{
    (event: 'retry'): void
}>()
</script>

<template>
    <div class="text-neutral-primary rounded-container-lg flex flex-col items-start">
        <svg
            v-if="isSuccess"
            class="size-[80px] md:size-[96px]"
            viewBox="0 0 96 96"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="48"
                cy="48"
                r="48"
                fill="#0B9747"
                fill-opacity="0.1"
            />
            <circle
                cx="48.0001"
                cy="47.9991"
                r="26.88"
                fill="#0B9747"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M47.9987 58.2392C53.6541 58.2392 58.2387 53.6546 58.2387 47.9992C58.2387 42.3438 53.6541 37.7592 47.9987 37.7592C42.3433 37.7592 37.7587 42.3438 37.7587 47.9992C37.7587 53.6546 42.3433 58.2392 47.9987 58.2392ZM47.9987 60.7992C55.068 60.7992 60.7987 55.0685 60.7987 47.9992C60.7987 40.93 55.068 35.1992 47.9987 35.1992C40.9295 35.1992 35.1987 40.93 35.1987 47.9992C35.1987 55.0685 40.9295 60.7992 47.9987 60.7992Z"
                fill="white"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M54.0238 43.8941C54.5237 44.394 54.5237 45.2044 54.0238 45.7043L47.6238 52.1043C47.124 52.6042 46.3135 52.6042 45.8136 52.1043L41.9736 48.2643C41.4738 47.7644 41.4738 46.954 41.9736 46.4541C42.4735 45.9543 43.284 45.9543 43.7838 46.4541L46.7187 49.389L52.2136 43.8941C52.7135 43.3943 53.524 43.3943 54.0238 43.8941Z"
                fill="white"
            />
        </svg>
        <svg
            v-else
            class="size-[80px] md:size-[96px]"
            viewBox="0 0 96 96"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="48"
                cy="48"
                r="48"
                fill="#C92C39"
                fill-opacity="0.1"
            />
            <circle
                cx="48.0001"
                cy="47.9991"
                r="26.88"
                fill="#C92C39"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M47.9997 58.2392C53.6551 58.2392 58.2397 53.6546 58.2397 47.9992C58.2397 42.3438 53.6551 37.7592 47.9997 37.7592C42.3443 37.7592 37.7597 42.3438 37.7597 47.9992C37.7597 53.6546 42.3443 58.2392 47.9997 58.2392ZM47.9997 60.7992C55.069 60.7992 60.7997 55.0685 60.7997 47.9992C60.7997 40.93 55.069 35.1992 47.9997 35.1992C40.9305 35.1992 35.1997 40.93 35.1997 47.9992C35.1997 55.0685 40.9305 60.7992 47.9997 60.7992Z"
                fill="white"
            />
            <path
                d="M49.2797 53.1192C49.2797 53.8261 48.7066 54.3992 47.9997 54.3992C47.2928 54.3992 46.7197 53.8261 46.7197 53.1192C46.7197 52.4123 47.2928 51.8392 47.9997 51.8392C48.7066 51.8392 49.2797 52.4123 49.2797 53.1192Z"
                fill="white"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M47.9997 41.5992C48.7066 41.5992 49.2797 42.1723 49.2797 42.8792V47.9992C49.2797 48.7061 48.7066 49.2792 47.9997 49.2792C47.2928 49.2792 46.7197 48.7061 46.7197 47.9992L46.7197 42.8792C46.7197 42.1723 47.2928 41.5992 47.9997 41.5992Z"
                fill="white"
            />
        </svg>
        <h3
            v-html-gpp="title"
            class="heading-sm mt-md lg:mt-lg"
        />
        <p
            v-html-gpp="description"
            class="paragraph-lg mt-md lg:mt-lg"
        />
        <BaseButton
            v-if="drawerType && isSuccess"
            class="mt-md lg:mt-lg"
            variant="primary"
            size="MEDIUM"
            data-test="lead-form-back-homepage"
            href="/"
        >
            PRZEJDŹ DO STRONY GŁÓWNEJ
        </BaseButton>
        <BaseButton
            v-if="!isSuccess"
            class="mt-md lg:mt-lg max-md:w-full"
            variant="primary"
            size="MEDIUM"
            data-test="lead-form-try-again"
            @click="emit('retry')"
        >
            SPRÓBUJ PONOWNIE
        </BaseButton>
    </div>
</template>
